import { Kapkriteria } from "~app/common/models/constants";
import { IProduktmatris } from "../../models/IProduktdefinition";

export class Produktmatris {
    startdiameter: number;
    startlangd: number;
    begransning: number;
    distribution: number;
    pris: number;
    radprisBeraknat?: number;
    kapkriteria: string;
    markning1: boolean;
    markning2: boolean;
    markning3: boolean;
    dirty?: boolean;

    constructor(produktmatris?: IProduktmatris) {
        this.startdiameter = produktmatris?.startdiameter;
        this.startlangd = produktmatris?.startlangd;
        this.begransning = produktmatris?.begransning;
        this.distribution = produktmatris?.distribution;
        this.pris = produktmatris?.pris;
        this.kapkriteria = produktmatris?.kapkriteria;
        this.markning1 = produktmatris?.markning1;
        this.markning2 = produktmatris?.markning2;
        this.markning3 = produktmatris?.markning3;
    }

    static createNew(startdiameter: number, startlangd: number) {
        const entry = new Produktmatris();
        entry.startdiameter = startdiameter;
        entry.startlangd = startlangd;
        entry.begransning = 0;
        entry.distribution = 0;
        entry.pris = 0;
        entry.kapkriteria = Kapkriteria.ingaBegransningar;
        entry.markning1 = false;
        entry.markning2 = false;
        entry.markning3 = false;
        entry.dirty = true;
        return entry;
    }

    get key() {
        return Produktmatris.getKey(this.startlangd, this.startdiameter);
    }

    static getKey(startlangd: number, startdiameter: number) {
        return `${startlangd}:${startdiameter}`;
    }

    markAsDirty = () => {
        this.dirty = true;
    };

    inheritLangd(pmData: Produktmatris) {
        this.pris = pmData.pris;
        this.kapkriteria = pmData.kapkriteria;
        this.markning1 = pmData.markning1;
        this.markning2 = pmData.markning2;
        this.markning3 = pmData.markning3;
    }

    inheritDiameter(pmData: Produktmatris) {
        this.pris = pmData.pris;
        this.kapkriteria = pmData.kapkriteria;
        this.markning1 = pmData.markning1;
        this.markning2 = pmData.markning2;
        this.markning3 = pmData.markning3;
        this.distribution = pmData.distribution;
    }

    inheritMassediteringProperties(data: Produktmatris) {
        this.pris = data.pris;
        this.distribution = data.distribution;
    }

    mapToDto(): IProduktmatris {
        return ({
            begransning: this.begransning,
            distribution: this.distribution,
            kapkriteria: this.kapkriteria,
            markning1: this.markning1,
            markning2: this.markning2,
            markning3: this.markning3,
            pris: this.pris,
            startdiameter: this.startdiameter,
            startlangd: this.startlangd
        });
    }
}
